import produce from 'immer';
import { COMPONENT_DISPLAY_NAME, COMPONENT_TYPE } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { generateNodeId } from 'utils/generate-id';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';
import { createButtonDefaults } from '../button/recipe';

export const buttonSubmit = (
	context: CreationContextFor<typeof COMPONENT_TYPE.BUTTON_SUBMIT>
): CreatedBuildingBlock<typeof COMPONENT_TYPE.BUTTON_SUBMIT> => {
	const type = COMPONENT_TYPE.BUTTON_SUBMIT;

	return produce(
		createModel({
			type,
			...createButtonDefaults(context, type),
		}),
		draft => {
			draft.uiConfig.editorProps.name = COMPONENT_DISPLAY_NAME[type];
			draft.uiConfig.componentProps[UNIFORM_PROPS.btnSubmit] = true;
			draft.uiConfig.nodeProps.id = generateNodeId(draft._id, type);
		}
	) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.BUTTON_SUBMIT>;
};
